import { Toast, Tooltip } from "./_bootstrap";

import "../components/navbar/navbar";
import "../components/paragraph/carousel";
import "../components/paragraph/headlines";
import "../components/paragraph/youtube-episodes";
import "../components/paragraph/links-as-buttons";
import "../components/paragraph/paragraph--type--tabs";
import "../components/paragraph/paragraph--type--blog-posts";

(function() {
  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach(tooltipElement => new Tooltip(tooltipElement));

  // * Toast initialization, remove it if not necessary
  document
    .querySelectorAll(".toast")
    .forEach(toastElement => new Toast(toastElement));
})();
